import axios from 'axios';
import { APIURL }  from './index';
import { encodeUrl } from '../utility/tool';

export const POSTLIST = 'POSTLIST';
export const POSTLIST_ERROR = 'POSTLIST_ERROR';
export const POSTLIST_ISLOADING = 'POSTLIST_ISLOADING';

export function fetch_postlist(fid,period,tagarr,sourceValue,token) {
  let url = `${APIURL}/KOLHotpost?fid=${fid}&period=${period}&tags=${tagarr}&source=${sourceValue}&token=${token}`
  let newEncodeUrl = encodeUrl(url)

  return (dispatch) => {
   const request = axios.get(newEncodeUrl)
   dispatch(postlist_isloading(true))
   request.then((response) =>{
    dispatch(postlist_error(false))
    return response; 
   })
  .then((response)=>{
    dispatch(postlist_success(response))
    dispatch(postlist_isloading(false))
   })
  .catch((err) => {
    dispatch(postlist_isloading(false));
    return dispatch(postlist_error(err.response))
  });
  }
}

export function postlist_isloading(bool){
  return {
    type: POSTLIST_ISLOADING,
    isLoading: bool
  }
}

export function postlist_success(response){
  return {
      type:POSTLIST,
      payload: response
    }
}

export function postlist_error(bool){
  return {
    type:POSTLIST_ERROR,
    hasErrored: bool
  }
}


// WEBPACK FOOTER //
// ./src/actions/fetch_postlist.js